import { useEffect } from 'react';

interface MetaUpdaterProps {
    title?: string;
    description?: string;
    keywords?: string;
}

const MetaUpdater: React.FC<MetaUpdaterProps> = ({ title, description, keywords }) => {
    useEffect(() => {
        if (title) {
            document.title = title;
        }

        if (description) {
            const metaDescription = document.querySelector('meta[name="description"]');
            if (metaDescription) {
                metaDescription.setAttribute('content', description);
            } else {
                const newMeta = document.createElement('meta');
                newMeta.name = 'description';
                newMeta.content = description;
                document.head.appendChild(newMeta);
            }
        }

        if (keywords) {
            const metaKeywords = document.querySelector('meta[name="keywords"]');
            if (metaKeywords) {
                metaKeywords.setAttribute('content', keywords);
            } else {
                const newMeta = document.createElement('meta');
                newMeta.name = 'keywords';
                newMeta.content = keywords;
                document.head.appendChild(newMeta);
            }
        }
    }, [title, description, keywords]);

    return null;
};

export default MetaUpdater;